import { Link } from 'react-router-dom';
import { siteName, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">{siteName}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your independent educational resource for mastering Basetao spreadsheets. We provide free templates, expert guides, and honest reviews to help shoppers organize orders, calculate shipping costs, and make smarter purchasing decisions.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3 uppercase tracking-wider">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Home</Link>
              <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Complete Guide</Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Official Store</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3 uppercase tracking-wider">Disclaimer</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              This website provides independent educational information about Basetao spreadsheets and is not officially affiliated with or endorsed by Basetao. All trademarks belong to their respective owners. We do not store, access, or share any personal spreadsheet data or shopping records.
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-6xl mx-auto">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteName}. All rights reserved. Built for the global shopping community.
          </p>
          <div className="flex items-center gap-4">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer">Official Store</a>
            <span className="text-foreground-300">|</span>
            <span className="text-xs text-foreground-500">Not affiliated with Basetao</span>
          </div>
        </div>
      </div>
    </footer>
  );
}